import FormMaker from 'components/organisms/layout/form/FormMaker';
import useFavoriteList from 'hooks/useFavoriteList';
import React from 'react';
import { useSelector } from 'react-redux';
import { Validator } from 'utils/validators';
import Drawer from 'components/organisms/layout/modals/Drawer';
import { Container } from './styles';

const AddFavoriteDrawer = () => {
    const favoriteList = useSelector((state) => state.favoriteList);
    const hook = useFavoriteList();

    const submit = async (data) => {
        await hook
            .add(data)
            .then(() => hook.closeAddModal())
            .catch(() => {});
    };

    const form = [
        [
            {
                text: 'Dê um nome a sua lista',
                type: 'label'
            }
        ],
        [
            {
                id: 'description',
                type: 'text',
                label: 'Nome da lista',
                message: 'Máximo 50 caracteres',
                validation: Validator.string()
                    .required('Nome da lista é obrigatório')
                    .max(50, 'Nome da lista deve ter no máximo 50 caracteres')
            }
        ]
    ];

    return (
        <Drawer
            title="Criar lista de favodfsdfsdfritos"
            active={favoriteList.addModal}
            close={() => hook.closeAddModal()}
            open={() => hook.openAddModal()}
        >
            <Container>
                <FormMaker data={form} formSubmit={submit} fullWidthButtonSubmit submitText="Criar" noConfirm />
            </Container>
        </Drawer>
    );
};

export default AddFavoriteDrawer;
